import apiClient from "@/shared/api/apiClient5";

export const getLogList = async (params) => {
  try {
    const { data } = await apiClient.get("/api/v1/log-entry/", {
      params,
    });
    return data;
  } catch (e) {
    console.error("getLogList failed", e);
  }
};

export const getEntityLogList = async (params) => {
  try {
    const { data } = await apiClient.get("/api/v1/log-entry/", {
      params,
    });
    return data;
  } catch (e) {
    console.error("getEntityLogList failed", e);
  }
};

export const exportLogList = async (params) => {
  try {
    const { data } = await apiClient.get("/api/v1/log-entry/export/excel/", {
      params,
      responseType: "blob",
    });
    return data;
  } catch (e) {
    console.error("exportLogList failed", e);
  }
};
export const getLogItem = async (id) => {
  try {
    const { data } = await apiClient.get(`/api/v1/log-entry/${id}/`);
    return data;
  } catch (e) {
    console.error("getLogItem failed", e);
  }
};
